import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Tailwind (base/components/utilities)
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Service worker: o que esta app precisa nao e de abrir depressa, e de
// **abrir**. Um agente a meio de um cadastro numa zona sem cobertura nao pode
// ficar com um ecra branco — e a fila de envio so se esvazia sozinha com a app
// fechada se houver service worker para o browser acordar.
//
// Nunca guarda o index.html: foi isso que, do lado do site, prendeu as pessoas
// numa shell velha a pedir chunks que ja nao existiam.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // Sem service worker a app funciona na mesma, so sem instalar nem fila
      // automatica em segundo plano.
    });
  });
}

reportWebVitals();
